<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'TEMPLATES' }]"
></breadcrumbs>

<page-header title="TEMPLATES"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('results')"
  [itemsPerPage]="getQueryParam('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getQueryParam('page')"
  (onPageChange)="handlePageChange($event)"
  (onPageSizeChange)="handlePageSizeChange($event)"
  (onSort)="handleSort($event)"
  [sort]="getQueryParam('sort')"
  [orderBy]="getQueryParam('order_by')"
  [columns]="columns"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['create']"
        class="button is-small is-info"
        translationEditableDirective="CREATE_TEMPLATE"
        >{{ 'CREATE_TEMPLATE' | translate }}</a
      >
      <button
        type="button"
        class="button is-small"
        translationEditableDirective="TEMPLATE_TAGS"
        style="outline: none; box-shadow: none; margin-left: auto"
        (click)="isTagsVisible = true"
      >
        {{ 'TEMPLATE_TAGS' | translate }}
      </button>
      <button
        type="button"
        class="button is-primary is-small"
        translationEditableDirective="TEST_TEMPLATE"
        style="outline: none; box-shadow: none; margin-left: auto"
        (click)="isTestTemplateVisible = true"
      >
        {{ 'TEST_TEMPLATE' | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template #addonRight>
    <form>
      <input
        class="input is-small"
        type="text"
        (input)="handleFilterChange($event)"
        [value]="getQueryParam('keyword')"
        name="keyword"
        [placeholder]="'SEARCH' | translate"
        [translationEditableModalDirective]="['SEARCH']"
      />
    </form>
  </ng-template>

  <ng-template let-row="row" #actionsColumn>
    <alert #deleteAlert (confirm)="deleteTemplate(row.get('id'))" titleTrnKey="ARE_YOU_SURE" textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS" />
    <div class="buttons m-0">
      <a
        [routerLink]="[row.get('id'), 'update']"
        class="button is-small"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
      <button
        class="button is-danger is-small"
        (click)="deleteAlert.fire()"
        translationEditableDirective="DELETE"
      >
        {{ 'DELETE' | translate }}
      </button>
    </div>
  </ng-template>
</app-table>

<template-tags
  [open]="isTagsVisible"
  (onClose)="isTagsVisible = false"
></template-tags>

<test-template
  [open]="isTestTemplateVisible"
  (onClose)="isTestTemplateVisible = false"
></test-template>
